import TYPES from './types';
import { getSummary as fetchSummary } from '../../../api/amendment';

export const getSummary = ({ year }) => {
  return async dispatch => {
    try {
      const summary = await fetchSummary({ year });

      return dispatch({
        type: TYPES.summaryData,
        payload: { summary: summary.data }
      })
    }
    catch (error) {
      return dispatch({ type: TYPES.summaryRequestError })
    }
  }
}
